<template>
  <div class="serviceDetail">
    <Header :isShadow="false" title="网点信息"> </Header>
    <div class="pageFooterPage" style="margin-top: 20px">
      <h2>{{ store.name }}</h2>
      <div class="pageFlexBetween time">
        <p>服务时间：{{ store.openTime }}-{{ store.closeTime }}</p>
        <!-- <div class="pageFlex word" style="color: var(--redColor)">
          <i class="iconfont left iconstar"></i><span>推荐网点</span>
        </div> -->
      </div>
      <div class="card pageDefaultRadius">
        <van-image height="200" width="100%" fit="fill" :src="store.imageUrl" />
        <div class="pageFlexBetween address">
          <p>地址：{{ store.address }}</p>
          <!-- <div class="pageFlex word" style="color: var(--depBlueColor)">
            <i class="iconfont left iconmap"></i
            ><span>{{ store.distance }}km</span>
          </div> -->
        </div>
      </div>
      <div class="pageFlexBetween slide">
        <div class="title">
          <h3 class="pageFlex">
            <span style="background-color: var(--depYelColor)"></span>
            服务特色
          </h3>
          <span class="desc">如需预约，可联系网点预约</span>
        </div>
        <div class="pageFlex phone">
          <div class="pageBgBlock">
            <a :href="linkPhone"><i class="iconfont iconphone"></i></a>
          </div>
          <div class="line"></div>
          <div class="pageBgBlock">
            <i class="iconfont iconaddress" @click="locationShow"></i>
          </div>
        </div>
      </div>
      <!-- 提示 -->
      <div class="pagesTips">
        <h5><i class="iconfont iconu268"></i><span>帮助提示</span></h5>
        <div class="contents">
          <ul style="margin-left: 15px; color: #aaa">
            <li style="list-style: disc">
              <span>请合理安排服务时间，如需预约可先联系网点预约</span>
            </li>
            <li style="list-style: disc">
              <span>服务由合作方提供，服务咨询可咨询网点</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 底部 -->
  </div>
</template>

<script>
import { wechatAuth } from "api/wechatSDK";

export default {
  data() {
    return {
      store: this.$store.state.storeInfo,
      linkPhone: "",
    };
  },
  created() {
    wechatAuth(["openLocation"]);
    this.linkPhone = "tel:" + this.store.linkPhone;
  },
  methods: {
    locationShow() {
      wx.openLocation({
        latitude: parseFloat(this.store.latitude), // 纬度，浮点数，范围为90 ~ -90
        longitude: parseFloat(this.store.longitude), // 经度，浮点数，范围为180 ~ -180。
        name: this.store.name, // 位置名
        address: this.store.address, // 地址详情说明
        scale: 17, // 地图缩放级别,整型值,范围从1~28。默认为最大
        infoUrl: "", // 在查看位置界面底部显示的超链接,可点击跳转
      });
    },
  },
};
</script>

<style lang="less" scoped>
.serviceDetail {
  h2 {
    font-size: 20px;
    color: #000000;
    margin-bottom: 8px;
  }
  .time {
    font-size: var(--pFont);
    color: var(--depHidColor);
    margin-bottom: 15px;
  }
  .card {
    margin-bottom: 20px;
    background: #fff;
    .address {
      font-size: var(--spanFont);
      padding: 8px 15px;
      color: var(--depHidColor);
      p {
        width: 75%;
      }
      .left {
        margin-right: 0px;
      }
    }
  }
  .slide {
    margin-bottom: 20px;
    .title {
      h3 {
        margin: 0 0 4px;
        font-weight: var(--defaultFontWeight);
        font-size: var(--middleFont);
        color: var(--titleColor);
        span {
          width: 5px;
          height: 16px;
          margin-right: 8px;
          border-radius: 20px;
        }
      }
      .desc {
        font-size: var(--pFont);
        color: var(--hidColor);
        margin-left: 12px;
        display: inline-block;
      }
    }
    .phone {
      .pageBgBlock {
        width: 40px;
        height: 40px;
        background: #fff;
        .iconfont {
          font-size: 20px;
        }
        .iconphone {
          color: var(--greenColor);
        }
        .iconaddress {
          color: var(--depBlueColor);
        }
      }
      .line {
        width: 1px;
        height: 30px;
        background: #dad5d5;
        margin: 0 14px;
      }
    }
  }
  .productList {
    background: #fff;
    height: 60px;
    .title {
      padding-left: 10px;
      .divider {
        width: 1px;
        position: relative;
        height: 60px;
      }
    }
    .iconcar {
      padding-right: 10px;
      font-size: 28px;
      color: var(--depBlueColor);
    }
    .right {
      height: 100%;
      .price {
        color: var(--redColor);
        font-size: 14px;
        margin-right: 15px;
        .button {
          padding: 0 15px;
          text-align: center;
          border: 1px solid var(--hidColor);
          border-radius: 5px;
        }
        .iconmoney {
          font-size: 18px;
        }
      }
      .use {
        font-size: 14px;
        border-radius: 0 5px 5px 0;
        background-color: var(--depBlueColor);
        height: 100%;
        width: 40px;
        .text {
          color: #fff;
          writing-mode: vertical-lr;
        }
        .count {
          position: absolute;
          border-radius: 999px;
          width: 22px;
          height: 21px;
          background-color: #fff;
          color: #0095eb;
          text-align: center;
          line-height: 20px;
          margin-left: 40px;
        }
      }
    }
  }
  .pagesTips {
    font-size: var(--smallFont);
    line-height: 1.5em;
    color: #999;
    margin: 16px 0px;
    box-sizing: border-box;
    h5 {
      font-size: 13px;
      .iconfont {
        float: left;
        margin-right: 8px;
        font-size: 18px;
      }
    }
    .contents {
      color: #7f7f7f;
      margin: 5px 2px;
      font-size: 13px;
    }
  }
}
.word {
  padding: 1px 0;
  .iconfont {
    display: inline-block;
    font-size: 20px;
  }
}
</style>